import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MeetingListEntry } from '@reflact/spftypes';
import { QuerstionService } from '../questionlist/table-complete/question.service';

/** How often the meeting list (incl. live participant counts) is re-fetched
 * while this page is open - see ngOnInit/ngOnDestroy. */
const REFRESH_INTERVAL_MS = 15000;

@Component({
  selector: 'app-meeting-picker',
  templateUrl: './meeting-picker.component.html',
  styles: []
})
export class MeetingPickerComponent implements OnInit, OnDestroy {
  public meetings: MeetingListEntry[] = [];
  public isLoading = true;
  public busyScoId: string;
  public errorMessage: string | undefined;

  private refreshHandle: ReturnType<typeof setInterval> | undefined;

  constructor(public service: QuerstionService, private router: Router) { }

  async ngOnInit() {
    this.isLoading = true;
    this.meetings = await this.service.loadMeetingList();
    this.isLoading = false;
    // Surface an error from a failed deep-link redirect (see WatchMeetingComponent) -
    // e.g. the pod's "Fragen verwalten" button for a meeting this moderator has no
    // host/mini-host permission on.
    if (this.service.lastJoinError) {
      this.errorMessage = this.service.lastJoinError;
    }
    // The list (esp. liveParticipantCount) is only a snapshot from the moment
    // it's fetched - keep it fresh while a moderator is looking at this page.
    this.refreshHandle = setInterval(async () => {
      this.meetings = await this.service.loadMeetingList();
    }, REFRESH_INTERVAL_MS);
  }

  ngOnDestroy() {
    if (this.refreshHandle != null) {
      clearInterval(this.refreshHandle);
    }
  }

  public isWatching(meeting: MeetingListEntry): boolean {
    return this.service.isWatchingScoId(meeting.scoId);
  }

  /**
   * Watches this one meeting (automatically releasing any other one that was
   * being watched, see QuerstionService.joinMeeting) and goes straight to the
   * question list - only one meeting can ever be watched at a time, so there's
   * no separate "continue" step anymore. If joining fails (e.g. the meeting
   * couldn't be resolved on the server), stay on this page and show the error
   * instead of navigating to an empty question list.
   */
  public async watch(meeting: MeetingListEntry) {
    this.busyScoId = meeting.scoId;
    this.errorMessage = undefined;
    let joined = true;
    if (!this.isWatching(meeting)) {
      joined = await this.service.joinMeeting(meeting);
    }
    this.busyScoId = undefined;
    if (!joined) {
      this.errorMessage = this.service.lastJoinError ?? 'Meeting konnte nicht geladen werden.';
      return;
    }
    this.router.navigate(['list']);
  }
}
